/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ic-list{margin-top:24px}.ic-list.no-margin{margin:0}.ic-list.no-indent .ic-list-header,.ic-list.no-indent [header]{padding:0}.ic-list.indent-1-pt .ic-list-header,.ic-list.indent-1-pt [header]{padding:0 8px}.ic-list.indent-2-pt .ic-list-header,.ic-list.indent-2-pt [header]{padding:0 16px}.ic-list .ic-list-header{color:#ababad;font-size:12px;margin-bottom:8px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/list.component.scss.ngstyle.js.pre-build-optimizer.js